import { useContext } from 'react'
import { navigate } from 'gatsby'
import { CognitoUser } from 'amazon-cognito-identity-js'

import userPool from '~utils/cognito'
import { UserContext } from '~context/provider'

const useOAuthSignOut = () => {
  const { user } = useContext(UserContext)

  const signOut = async () => {
    const refreshToken = user?.refreshToken

    if (!refreshToken) {
      throw new Error('No refresh token found')
    }

    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    })

    const body = new URLSearchParams({
      token: refreshToken,
      client_id: process.env.GATSBY_COGNITO_CLIENT_ID,
    })

    const url = new URL('/oauth2/revoke', process.env.GATSBY_COGNITO_URL)
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers,
        body,
      })

      console.log('%c Sign out response:', 'color: green', response)
      if (response?.ok) {
        const cognitoUser = new CognitoUser({
          Username: user?.username,
          Pool: userPool,
        })

        cognitoUser.signOut()
        localStorage.clear()
        navigate('/register')
      }
    } catch (error) {
      console.log('%c Error on sign out:', 'color:red', error)
    }
  }

  return { signOut }
}

export default useOAuthSignOut
